import { ArrowLeft, ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

/**
 * Direction-aware "next" arrow.
 * Points inward-forward in both RTL (←) and LTR (→) reading directions.
 */
export default function NextArrow({ size = 16, className }) {
  const { lang } = useLanguage();
  const Icon = lang === "ar" ? ArrowLeft : ArrowRight;
  return <Icon size={size} className={className} aria-hidden />;
}
